import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import logo from "@/assets/logo.png";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-app flex flex-col" data-testid="forgot-page">
      <div className="max-w-md w-full mx-auto px-6 py-10 flex-1 flex flex-col justify-center">
        <Link to="/" className="mb-8 flex justify-center">
          <img src={logo} alt="Meno Flames and Finesse" className="h-24 w-auto" />
        </Link>
        <div className="bg-white rounded-3xl card-shadow p-8">
          {sent ? (
            <div className="text-center" data-testid="forgot-sent">
              <div className="w-14 h-14 rounded-full bg-sage flex items-center justify-center mx-auto mb-4">
                <MailCheck size={24} className="text-brand" />
              </div>
              <h1 className="font-serif text-2xl font-bold text-ink">Check your email</h1>
              <p className="text-ink-soft text-sm mt-2">
                If an account exists for that email, we've sent a reset link. It expires in one hour.
              </p>
              <Link to="/login" className="inline-block mt-6 text-brand font-semibold">Back to log in</Link>
            </div>
          ) : (
            <>
              <h1 className="font-serif text-2xl font-bold text-ink">Reset your password</h1>
              <p className="text-ink-soft text-sm mt-2">Enter your email and we'll send you a reset link.</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <input
                  data-testid="forgot-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full rounded-xl border border-subtle bg-app px-4 py-3 text-ink outline-none focus:border-[var(--brand)]"
                  placeholder="you@email.com"
                />
                {error && <div className="text-sm text-red-600 bg-red-50 rounded-xl px-4 py-3">{error}</div>}
                <button
                  data-testid="forgot-submit"
                  disabled={busy}
                  className="w-full bg-brand hover:bg-[var(--brand-hover)] text-white font-semibold py-3.5 rounded-full transition-colors disabled:opacity-60"
                >
                  {busy ? "Sending…" : "Send reset link"}
                </button>
              </form>
              <Link to="/login" className="block text-center mt-5 text-sm text-ink-soft">Back to log in</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
